import { Entity, Field } from "typegraph";

class discount {
	@Field()
	public value: number;
}
@Entity({ many: "cartCoupon" })
export default class cartCoupon {
	@Field({entity:discount})
    public discount: discount;

    @Field()
    public messageResponse: string;
}



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/entities/CartCoupon.ts